import { defineMessages } from 'react-intl';

const messages = defineMessages({
  confirmLabel: {
    id: 'reviewAndSubmitVoucher.confirmLabel',
    defaultMessage:
      'By selecting this box, I confirm I have reviewed this Voucher and would like to submit it to TRACS.',
  },
  reviewVoucherDetailsTitle: {
    id: 'reviewAndSubmitVoucher.reviewVoucherDetailsTitle',
    defaultMessage: 'Review Voucher Details',
  },
  unitsSectionTitle: {
    id: 'reviewAndSubmitVoucher.unitsSectionTitle',
    defaultMessage: 'Units',
  },
  unitsReceivingSubsidyUnderContract: {
    id: 'reviewAndSubmitVoucher.unitsReceivingSubsidyUnderContract',
    defaultMessage: 'Units receiving subsidy under this contract',
  },
  unitsAbatedUnderThisContract: {
    id: 'reviewAndSubmitVoucher.unitsAbatedUnderThisContract',
    defaultMessage: 'Units abated under this contract',
  },
  unitsVacantUnderThisContract: {
    id: 'reviewAndSubmitVoucher.unitsVacantUnderThisContract',
    defaultMessage: 'Units vacant under this contract',
  },
  occupiedByMarketRentTenants: {
    id: 'reviewAndSubmitVoucher.occupiedByMarketRentTenants',
    defaultMessage: 'Occupied by Market Rent Tenants',
  },
  pendingSectionTitle: {
    id: 'reviewAndSubmitVoucher.pendingSectionTitle',
    defaultMessage: 'Pending',
  },
  moveInsScheduledForMonthLabel: {
    id: 'reviewAndSubmitVoucher.moveInsScheduledForMonthLabel',
    defaultMessage: 'Move-Ins Scheduled for {voucherMonth}',
  },
  moveOutsScheduledForMonthLabel: {
    id: 'reviewAndSubmitVoucher.moveOutsScheduledForMonthLabel',
    defaultMessage: 'Move-Outs Scheduled for {voucherMonth}',
  },
  transfersScheduledForMonthLabel: {
    id: 'reviewAndSubmitVoucher.transfersScheduledForMonthLabel',
    defaultMessage: 'Transfers Scheduled for {voucherMonth}',
  },
  recertsExpiringInMonthLabel: {
    id: 'reviewAndSubmitVoucher.recertsExpiringInMonthLabel',
    defaultMessage: 'Recerts Expiring in {voucherMonth}',
  },
  accountingSectionTitle: {
    id: 'reviewAndSubmitVoucher.accountingSectionTitle',
    defaultMessage: 'Accounting',
  },
  accountingColumnHeader: {
    id: 'reviewAndSubmitVoucher.accountingColumnHeader',
    defaultMessage: 'Accounting',
  },
  requestedAmountColumnHeader: {
    id: 'reviewAndSubmitVoucher.requestedAmountColumnHeader',
    defaultMessage: 'Requested Amount',
  },
  caHudApprovedAmountColumnHeader: {
    id: 'reviewAndSubmitVoucher.caHudApprovedAmountColumnHeader',
    defaultMessage: 'CA/HUD Approved Amount',
  },
  caHudApprovedAmountTooltip: {
    id: 'reviewAndSubmitVoucher.caHudApprovedAmountTooltip',
    defaultMessage:
      'Values in this column will populate once voucher is approved.',
  },
  regularTenantAssistancePaymentsLabel: {
    id: 'reviewAndSubmitVoucher.regularTenantAssistancePaymentsLabel',
    defaultMessage: 'Regular Tenant Assistance Payments',
  },
  adjustmentsToRegularTenantAssistancePaymentsLabel: {
    id: 'reviewAndSubmitVoucher.adjustmentsToRegularTenantAssistancePaymentsLabel',
    defaultMessage: 'Adjustments to Regular Tenant Assistance Payments',
  },
  specialClaimsLabel: {
    id: 'reviewAndSubmitVoucher.specialClaimsLabel',
    defaultMessage: 'Special Claims',
  },
  repaymentAgreementsLabel: {
    id: 'reviewAndSubmitVoucher.repaymentAgreementsLabel',
    defaultMessage: 'Repayment Agreements',
  },
  miscellaneousAccountingLabel: {
    id: 'reviewAndSubmitVoucher.miscellaneousAccountingLabel',
    defaultMessage: 'Miscellaneous Accounting',
  },
  totalsSectionTitle: {
    id: 'reviewAndSubmitVoucher.totalsSectionTitle',
    defaultMessage: 'Totals',
  },
  totalVoucherAmountLabel: {
    id: 'reviewAndSubmitVoucher.totalVoucherAmountLabel',
    defaultMessage: 'Total Voucher Amount',
  },
  totalRequestedAmountLabel: {
    id: 'reviewAndSubmitVoucher.totalRequestedAmountLabel',
    defaultMessage: 'Total Requested Amount',
  },
  totalApprovedAmountLabel: {
    id: 'reviewAndSubmitVoucher.totalApprovedAmountLabel',
    defaultMessage: 'Total Approved Amount',
  },
  totalCaHudApprovedAmountLabel: {
    id: 'reviewAndSubmitVoucher.totalCaHudApprovedAmountLabel',
    defaultMessage: 'Total CA/HUD Approved Amount',
  },
  totalVarianceAmountLabel: {
    id: 'reviewAndSubmitVoucher.totalVarianceAmountLabel',
    defaultMessage: 'Total Variance',
  },
  toastrSuccessTitle: {
    id: 'reviewAndSubmitVoucher.toastrSuccessTitle',
    defaultMessage: 'Success',
  },
  toastrSuccessBody: {
    id: 'reviewAndSubmitVoucher.toastrSuccessBody',
    defaultMessage: 'Voucher was successfully submitted to TRACS.',
  },
  toastrErrorTitle: {
    id: 'reviewAndSubmitVoucher.toastrErrorTitle',
    defaultMessage: 'Unable to Submit Voucher',
  },
  toastrErrorBody: {
    id: 'reviewAndSubmitVoucher.toastrErrorBody',
    defaultMessage:
      'Voucher could not be submitted to TRACS. Please try again.',
  },
  modalTitle: {
    id: 'reviewAndSubmitVoucher.modalTitle',
    defaultMessage: 'Submit Voucher to TRACS',
  },
  modalDescription: {
    id: 'reviewAndSubmitVoucher.modalDescription',
    defaultMessage:
      'Please enter your IMAXX WASS ID and Password to submit this Voucher to TRACS.',
  },
  modalButtonText: {
    id: 'reviewAndSubmitVoucher.modalButtonText',
    defaultMessage: 'Submit to TRACS',
  },
  modalButtonTooltip: {
    id: 'reviewAndSubmitVoucher.modalButtonTooltip',
    defaultMessage: 'Submit this Voucher to TRACS.',
  },
  priorVoucherMustBeApprovedTooltip: {
    id: 'reviewAndSubmitVoucher.priorVoucherMustBeApprovedTooltip',
    defaultMessage:
      '{voucherYearMonth} must be approved before submitting this voucher.',
  },
  submitButtonText: {
    id: 'reviewAndSubmitVoucher.submitButtonText',
    defaultMessage: 'Submit',
  },
  reviewSubmitGatingBanner: {
    id: 'reviewAndSubmitVoucher.reviewSubmitGatingBanner',
    defaultMessage:
      'New Tenant Events must be submitted or moved to another Voucher before the ' +
      'Voucher can be executed and sent to TRACS.',
  },
  alreadySubmittedToTracsTooltip: {
    id: 'reviewAndSubmitVoucher.alreadySubmittedToTracsTooltip',
    defaultMessage: 'This Voucher has already been submitted to TRACS.',
  },
  tracsActionsUnavailableNonDraftTooltip: {
    id: 'reviewAndSubmitVoucher.tracsActionsUnavailableNonDraftTooltip',
    defaultMessage:
      'Prepare Execution and Submit to TRACS are only available when this Voucher is in Draft status.',
  },
  voucherHasNoDataTooltip: {
    id: 'reviewAndSubmitVoucher.voucherHasNoDataTooltip',
    defaultMessage: 'This Voucher has no data to be submitted.',
  },
  validationBlockingTooltip: {
    id: 'reviewAndSubmitVoucher.validationBlockingTooltip',
    defaultMessage:
      'Regular Assistance has validation issues that must be resolved before submission.',
  },
  validationBlockingBanner: {
    id: 'reviewAndSubmitVoucher.validationBlockingBanner',
    defaultMessage:
      'Regular Assistance has validation issues. Resolve them before preparing execution or submitting to TRACS.',
  },
  draftChangesRequireResubmissionTooltip: {
    id: 'reviewAndSubmitVoucher.draftChangesRequireResubmissionTooltip',
    defaultMessage:
      'Prepare Execution must be completed before resubmitting the Voucher to TRACS.',
  },
});

export default messages;
